const services = [
  {
    icon: "ri-flashlight-line",
    title: "Emergency Passport",
    description:
      "Urgent passport processing for travelers with immediate departure needs. As fast as 24 hours for qualifying situations.",
  },
  {
    icon: "ri-passport-line",
    title: "Passport Renewal",
    description:
      "Fast renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older. Streamlined process.",
  },
  {
    icon: "ri-add-circle-line",
    title: "New Passport",
    description:
      "First-time passport application assistance with step-by-step guidance through the acceptance clerk process.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Lost or Stolen Passport",
    description:
      "Passport replacement service for lost or stolen passports. We guide you through Form DS-64 and the replacement process.",
  },
  {
    icon: "ri-parent-line",
    title: "Child Passport",
    description:
      "Passport services for minors under 16, with parental consent guidance and acceptance clerk appointment support in Broward County.",
  },
  {
    icon: "ri-edit-line",
    title: "Name Change",
    description:
      "Passport correction and name change service after marriage, divorce, or legal name changes. Fast turnaround available.",
  },
  {
    icon: "ri-shield-star-line",
    title: "Second Passport",
    description:
      "Second passport issuance for frequent travelers who need multiple valid passports for overlapping visa or travel requirements.",
  },
  {
    icon: "ri-archive-drawer-line",
    title: "Damaged Passport",
    description:
      "Damaged or mutilated passport replacement with guidance on documentation requirements and acceptance clerk procedures.",
  },
  {
    icon: "ri-bank-card-line",
    title: "Passport Card",
    description:
      "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean. REAL ID compliant.",
  },
];

export default function HollywoodServicesSection() {
  return (
    <section id="services" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">What We Offer</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Expedited Passport Services in Hollywood, FL
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From emergency same-day processing to standard expedited renewals, Fast Passport Center handles every passport situation for Hollywood and Broward County travelers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-4 flex-shrink-0">
                <i className={`${s.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{s.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed flex-1">{s.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
          >
            Get Started <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}